import { color } from '@starryui10/theme/color';
import styled from 'styled-components';

export const UL = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const Caption = styled.button`
    height: 100%;
    padding: 0 12px;
    text-align: left;
    cursor: pointer;

    &:hover {
        span {
            cursor: pointer;
        }
    }
`;

// To allow for tabIndex prop
export const ItemContainer = styled.li`
    display: grid;
    align-items: center;
    height: 40px;
    padding: 0 12px;
    border-radius: 4px;
    outline: 0;

    &:focus {
        border: 2px solid  ${color.Blue.B80};
    } 
`;
